// src/slices/Animal/reducer.js
import { createSlice } from "@reduxjs/toolkit";
import { addAnimal, getAnimals, getAnimalBySlug } from "./thunk";

const initialState = { loading: false, success: false, animal: null, animals: [], error: null };

const animalSlice = createSlice({
  name: "animal",

  initialState,

  reducers: {
    resetAnimalState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.animal = null;
      state.animals = [];
    }
  },

  extraReducers: (builder) => {
    builder

      // ================= Add Animal =================

      .addCase(addAnimal.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })

      .addCase(addAnimal.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.animal = action.payload;
      })

      .addCase(addAnimal.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      })

      // ================= Get All Animals =================

      .addCase(getAnimals.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getAnimals.fulfilled, (state, action) => {
        state.loading = false;
        state.animals = action.payload;
      })

      .addCase(getAnimals.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ================= Get Animal By Slug =================

      .addCase(getAnimalBySlug.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getAnimalBySlug.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.animal = action.payload;
      })

      .addCase(getAnimalBySlug.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { resetAnimalState } = animalSlice.actions;

export default animalSlice.reducer;
